import { StreamEl } from '@mi-front/ui';
import { Tooltip } from '@mui/material';
import { useIntl } from 'react-intl';
import { STREAM_UI_CONFIG } from '../../../../consts';
import { HatchedStrip } from './elements';

const TRACK_HEIGHT = STREAM_UI_CONFIG.focusTracksHeight;

/**
 * Renders a gap segment on the Live Topics track using the same hatched strip
 * as the full empty state, for time ranges where no topic was detected (gaps >= 1 minute).
 * MUI Tooltip is anchored to the pill (position where hover started), like the topic pill popup.
 */
export function GapSegmentPill({ from, to }: { from: number; to: number }) {
  const { formatMessage } = useIntl();
  const title = formatMessage({
    id: 'logger.streamScreen.liveTopics.noTopicsForRange',
    defaultMessage: 'No se detectaron temas en este rango',
  });
  return (
    <StreamEl ts={from} position="top" offsetY={4} style={{ pointerEvents: 'auto' }}>
      {(scale) => {
        const width = (scale(to) ?? 0) - (scale(from) ?? 0);
        return (
          <Tooltip title={title} placement="top">
            <div
              style={{
                width: Math.max(width, 4),
                height: TRACK_HEIGHT,
                borderRadius: 12,
                overflow: 'hidden',
              }}
            >
              <HatchedStrip />
            </div>
          </Tooltip>
        );
      }}
    </StreamEl>
  );
}
